import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ResumenLotesService {

  constructor(private http: HttpClient) {}

  getResumenLotes(idPrestador: number): Observable<ResponseContainerDTO> {
    return this.http.get<ResponseContainerDTO>(`${this.buildUrlApi('resumen')}/${idPrestador}`);
  }

  private buildUrlApi(method: string): string {
    return `${environment.apiUrl}` + method;
  }
}

export interface ResponseContainerDTO {
  message: string;
  response: ResumenLoteResponseDTO;
}

export interface ResumenLoteResponseDTO {
  message: string;
  listaResumen: LoteSummaryDTO[];
}

export interface LoteSummaryDTO {
  nroLote: string;
  cantTrabajadoresLote: number;
  cantExaAsignados: number;
  cantExaCargados: number;
}
